import { render, staticRenderFns } from "./SelectBusinessPaystubAction.vue?vue&type=template&id=5366a52a&scoped=true&"
import script from "./SelectBusinessPaystubAction.vue?vue&type=script&lang=ts&"
export * from "./SelectBusinessPaystubAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366a52a",
  null
  
)

export default component.exports